import { createApiClient } from '@mjl/shared';

/** Client My Apps / SSO — base URL dari VITE_SSO_URL (inline saat build CDN). */
export const ssoApi = createApiClient(import.meta.env.VITE_SSO_URL ?? '');
